<template>
    <div>
        <van-sticky>
            <Wp_user_banner ref="wp_user_banner" v-on:reload="reloadPage"></Wp_user_banner>
        </van-sticky>
        <!--        <div style="padding-top: 10px; padding-left: 10px"><h2>提款明细</h2></div>-->
        <!--        <Wp_my_pay_data></Wp_my_pay_data>-->
        <!--        <van-tabs v-model="active" >-->
        <!--            <van-tab>-->
        <!--                <div slot="title"><h3>提款明细</h3></div>-->
        <!--                <Wp_my_pay_data></Wp_my_pay_data>-->
        <!--            </van-tab>-->
        <!--            <van-tab>-->
        <!--                <div slot="title"><h3>代理数据</h3></div>-->
        <!--                <Wp_my_child_member></Wp_my_child_member>-->
        <!--            </van-tab>-->
        <!--        </van-tabs>-->

        <van-cell-group style="margin-top: 10px">
            <van-cell title="提款明细" is-link @click="payDataDetail"/>
            <van-cell title="邀请超级会员" label="建议微信中打开效果更佳" is-link @click="invite"></van-cell>
<!--            <van-cell title="修改密码" is-link @click="modifyPassword"/>-->
        </van-cell-group>

        <Wp_invite_by_qrcode :inviteId="invite_id" :activeShow="show_share_pop"
                             :wxUserInfo="wx_user_info"
                             useTo="mini_app"
        ></Wp_invite_by_qrcode>

    </div>
</template>

<script>

    import Wp_user_banner from "../custom/Wp_user_banner";
    import Wp_invite_by_qrcode from "../custom/Wp_invite_by_qrcode";

    export default {
        name: "Wp_mini_my",
        components: {Wp_invite_by_qrcode, Wp_user_banner},
        data() {
            return {
                active: 0,
                invite_id: "df98s0f",
                show_share_pop: "",
                wx_user_info: null,
                invite_status: true,

                app: {
                    app_id: 'wx441c534516758ef0',
                    app_secret: 'db330f7a282f73595bccdd448612f8bd',
                    url: this.$common.redirect_url,
                    url_hm: this.$common.redirect_url_hm,
                },
                test: '',
            }
        },

        created() {
            if (this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.open_id) {
                this.$log("已有数据")
                this.$log(this.$common.gloabl_wx_mini_user_info)
                this.wx_user_info = this.$common.gloabl_wx_mini_user_info;
            }
            // else{
            //     //otyOg4ozV6nx9neuSClF0EQonk-Y
            //     let openid = "";
            //     if(this.$common.gloabl_wx_openid){
            //         openid = this.$common.gloabl_wx_openid;
            //     }else{
            //         openid = this.$common.getUrlKey("openid");
            //     }
            //
            //     // this.$log("openid = " + openid)
            //     // this.$log(location.href)
            //
            //     this.getWxUserinfo(openid);
            // }


        },

        watch: {
            wx_user_info(value) {
                if (value) {
                    this.$refs.wp_user_banner.head_icon = value.headimgurl;
                    this.$refs.wp_user_banner.user_name = value.nickname;
                }
            },

        },

        methods: {
            /**
             * 通过openid小程序中获取用户信息
             */
            getWxUserinfo(openid){
                if(openid){
                    let params = {
                        open_id: openid
                    };

                    this.$getWxUserinfo(params, response=>{
                        // this.$log(response);
                        this.wx_user_info = response.data;
                        this.wx_user_info.nickname = this.wx_user_info.user_name;
                        this.wx_user_info.headimgurl = this.wx_user_info.user_icon;

                        this.$common.wx_user_info = this.wx_user_info;
                    })
                }
            },

            modifyPassword() {
                this.$router.push("modify_password");
            },

            is_weixn() {
                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    return true;
                } else {
                    return false;
                }
            },

            reloadPage() {
                window.location.reload();
            },

            payDataDetail() {
                this.$router.push('paydata')
            },
            invite() {
                if (this.is_weixn()) {
                    // this.wx_user_info = null;
                    if (this.wx_user_info) {
                        let timestamp = "_" + Date.parse(new Date());
                        this.show_share_pop = timestamp;
                    } else {
                        this.$dialog.alert({
                            message: "数据初始化中"
                        })
                    }
                } else {
                    let timestamp = "_" + Date.parse(new Date());
                    this.show_share_pop = timestamp;
                }
            },

            initWxUserInfo(fn) {
                // this.text = this.$common.getUrlParams();
                let code = this.$common.getUrlKey("code");
                if (code) {
                    //调用接口获取openId   参考文档https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421140842
                    this.getUserInfo(code, response => {
                        fn(response)
                    })
                } else {
                    this.getCodeApi("123")
                }
            },
            getCodeApi(state) {//获取code
                // let urlNow = encodeURIComponent(window.location.href);
                // snsapi_base 不需要用户点同意，直接跳转到授权后的页面，只能用于获取openid，不能获取用户基本信息
                // snsapi_userinfo 会征求用户同意，授权后，可以获取用户基本信息

                let scope = 'snsapi_base';    //snsapi_base  snsapi_userinfo //静默授权 用户无感知

                let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.app.app_id}&redirect_uri=${this.app.url_hm}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;

                this.url = url;
                //
                setTimeout(function () {
                    window.location.replace(url);
                }, 50)
            },
            jump() {
                window.location.replace(this.url);
            },
            getUserInfo(code, fn) {
                if (code) {
                    //地址为https://api.weixin.qq.com/sns/userinfo?access_token=ACCESS_TOKEN&openid=OPENID&lang=zh_CN
                    this.url_2 = `https://api.wapg.cn/jd_union/wechat/user_info?code=${code}&channel=${this.$store.state.username}&app_id=${this.app.app_id}&app_${this.app.app_secret}`;
                    let that = this;
                    this.$axios.get(this.url_2)
                        .then((res) => {
                            this.$log(res);
                            that.user_info = res
                            fn(res.data);
                        }).catch((c) => {
                        that.user_info = c;
                    })
                }
            }
        }
    }
</script>

<style scoped>
    .van-cell {
        font-size: 17px;
    }

</style>
